import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WHY } from "@/data/content";

export const WhyChooseUs = () => (
  <section id="why" className="py-24 sm:py-32 bg-ink text-white relative overflow-hidden grain" data-testid="why">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
      <div className="grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest-light mb-4">Why Sahi Claim</p>
            <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.05]">
              On your side of the table. <span className="text-forest-light">Always.</span>
            </h2>
            <p className="mt-6 text-zinc-400 max-w-lg text-lg">
              Insurers have adjusters, lawyers and actuaries. Now, so do you — a fully independent team whose only incentive is the size of your settlement.
            </p>
          </Reveal>

          <div className="mt-12 grid sm:grid-cols-2 gap-8">
            {WHY.map((w, i) => (
              <Reveal key={w.title} delay={i * 0.08}>
                <div className="flex gap-4" data-testid={`why-${i}`}>
                  <span className="mt-1 h-7 w-7 shrink-0 rounded-full bg-forest flex items-center justify-center">
                    <Check size={15} />
                  </span>
                  <div>
                    <h3 className="font-bold text-lg">{w.title}</h3>
                    <p className="mt-1 text-sm text-zinc-400 leading-relaxed">{w.copy}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6">
          <Reveal delay={0.15}>
            <motion.div className="relative rounded-3xl overflow-hidden aspect-[4/3] border border-zinc-800">
              <img src="https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/e203dad22ec243af4e044b03fffc6ae0b1c6f10c0a41702ac1eb31b34a3182dd.jpeg"
                alt="Advisor explaining claim documents to a client" loading="lazy" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent" />
            </motion.div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
